
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ClientContactFieldProps {
  email: string;
  phone: string;
  onEmailChange: (value: string) => void;
  onPhoneChange: (value: string) => void;
  isEmailReadOnly?: boolean;
}

export function ClientContactField({ 
  email, 
  phone, 
  onEmailChange, 
  onPhoneChange,
  isEmailReadOnly = false // Changed default to false to allow editing
}: ClientContactFieldProps) {
  const { t } = useTranslation("clients");

  return (
    <>
      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="email" className="text-right">
          {t("email")}
        </Label>
        <Input
          id="email"
          type="email"
          value={email}
          onChange={(e) => onEmailChange(e.target.value)}
          className="col-span-3"
          readOnly={isEmailReadOnly}
          disabled={isEmailReadOnly}
        />
        {isEmailReadOnly && (
          <div className="col-span-4 text-xs text-muted-foreground text-right pr-1">
            {t('profile.emailReadonly', { defaultValue: email ? "Email from auth system (readonly)" : "Email not available" })}
          </div>
        )}
      </div>

      <div className="grid grid-cols-4 items-center gap-4">
        <Label htmlFor="phone" className="text-right">
          {t("phone")}
        </Label>
        <Input
          id="phone"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          className="col-span-3"
        />
      </div>
    </>
  );
}
